module.exports = __webpack_public_path__ + "media/images/sp/stores/yokohama/yokohama_sns_03-f1897af9a6fc63642a90c3be21d8bf63.jpg";